import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import frFR from 'antd/locale/fr_FR';
import theme from './theme';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import BookingPage from './components/booking/BookingPage';
import LoginPage from './components/admin/LoginPage';
import AdminLayout from './components/admin/AdminLayout';
import DashboardPage from './components/admin/DashboardPage';
import PlanningPage from './components/admin/PlanningPage';
import TeamListPage from './components/admin/TeamListPage';
import AbsencePage from './components/admin/AbsencePage';
import ConfigPage from './components/admin/ConfigPage';
import AnalyticsPage from './components/admin/AnalyticsPage';
import OptimizerPage from './components/admin/OptimizerPage';
import ChatPage from './components/admin/ChatPage';
import DepotListPage from './components/admin/DepotListPage';

function App() {
  return (
    <ConfigProvider theme={theme} locale={frFR}>
      <AntApp>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public booking page */}
              <Route path="/" element={<BookingPage />} />

              {/* Admin login */}
              <Route path="/admin/login" element={<LoginPage />} />

              {/* Protected admin routes */}
              <Route path="/admin" element={
                <ProtectedRoute><AdminLayout /></ProtectedRoute>
              }>
                <Route index element={<DashboardPage />} />
                <Route path="planning" element={<PlanningPage />} />
                <Route path="teams" element={<TeamListPage />} />
                <Route path="depots" element={<DepotListPage />} />
                <Route path="absences" element={<AbsencePage />} />
                <Route path="analytics" element={<AnalyticsPage />} />
                <Route path="optimizer" element={<OptimizerPage />} />
                <Route path="chat" element={<ChatPage />} />
                <Route path="config" element={<ConfigPage />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
